import * as React from 'react';
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';
import { Fade } from '@atlassian/help-center-common-component/transitions';

export interface Props {
    helpText: string;
}

class RequestCreateFormHelpTextDumb extends React.Component<Props> {
    render() {
        return (
            <Fade in={!!this.props.helpText}>
                <HelpTextContainer dangerouslySetInnerHTML={{ __html: this.props.helpText }} />
            </Fade>
        );
    }
}

export default RequestCreateFormHelpTextDumb;

const HelpTextContainer = styled.div`
    margin-top: ${token('space.200', '16px')};
    margin-bottom: ${token('space.100', '8px')};
`;
